/* Book a wheelchair listing */
'use strict';

var $ = require('jquery');
var parsley = require('parsleyjs');

export default class BookWheelchairFormValidation {
    constructor(element) {
        this.root = element;
        this.form = this.root.querySelector('form');
        this.phoneNumbers = this.form.querySelector('.book-wheelchair__phone');
        this.phoneInputs = this.phoneNumbers ? this.phoneNumbers.querySelector('input') : null;
        this.toggleFieldParent = this.root.querySelectorAll('.book-wheelchair__toggle-fields');
        this.checkboxToggle = this.form.querySelector('.js-checkbox-toggle');
        this.postcodeField = this.root.querySelector('.book-wheelchair__postcode input');
        this.emailContainer = this.form.querySelector('.book-wheelchair__email');
        this.email = this.form.querySelector('.js-email');
        this.confirmEmail = this.form.querySelector('.js-confirm-email');
        this.submit = this.form.querySelector('.js-form-submit');

        this.parsleySetup();

        if (this.postcodeField) {
            this.form.addEventListener('submit', this.postcodeValidation.bind(this, this.postcodeField));
        }

        if (this.phoneNumbers) {
            this.form.addEventListener('submit', this.phoneValidation.bind(this, this.phoneNumbers));
            this.phoneInputs.addEventListener('keyup', this.phoneValidation.bind(this, this.phoneNumbers));
            
            if(this.phoneInputs.classList.contains('wc-phone-input')) {
                this.phoneNumbers.querySelector('input').addEventListener('keypress', e => {
                    const key = e ? e.which : window.event.keyCode;
                    if (key === 32) e.preventDefault();
                });
            }
            
        }

        if (this.email) {
            this.form.addEventListener('submit', this.matchingEmail.bind(this, this.confirmEmail));
            this.confirmEmail.addEventListener('keyup', this.matchingEmail.bind(this, this.confirmEmail));
        }

        if (this.toggleFieldParent) {
            for (let i = 0; i < this.toggleFieldParent.length; i++) {
                let toggleController = this.toggleFieldParent[i].querySelector('input[type=checkbox]');
                toggleController.addEventListener('change', this.toggleFields.bind(this, toggleController, this.toggleFieldParent[i]));
            }
        }

        if (this.submit) {
            this.submit.addEventListener('click', this.checkErrors);
        }
    }

    parsleySetup() {
        // Use this setup for latest vs of Parsley to accept 'excluded' options as to not
        // validate hidden fields and put errors in .book-wheelchair__error div for styling purposes
        // See warning about data-parsley-validate on official docs http://parsleyjs.org/doc/
        var parsleyConfig = {
            errorsContainer: function (pEle) {
                var $err;
                if ($(pEle.$element).parents('.book-wheelchair__radios').length > 0) {
                    $err = $(pEle.$element).parents('.book-wheelchair__radios').find('.book-wheelchair__error');
                } else if ($(pEle.$element).parents('.checkbox').length > 0) {
                    $err = $(pEle.$element).parents('.checkbox').next();
                } else {
                    $err = pEle.$element.siblings('.book-wheelchair__error');
                }

                return $err;
            },
            errorsWrapper: '<ul class="book-wheelchair__error-list"></ul>',
            excluded: 'input[type=hidden], [disabled], :hidden, [hidden]',
            focus: 'none'
        }
        
        $('form').parsley(parsleyConfig);
    }

    matchingEmail() {
        let errorDiv = this.emailContainer.querySelector('.book-wheelchair__error');
        let errorText = this.emailContainer.getAttribute('data-error-message');

        if (this.confirmEmail.value === this.email.value) {
            this.confirmEmail.classList.remove('has-error');
            errorDiv.innerHTML = '';
        } else {
            this.confirmEmail.classList.add('has-error');
            errorDiv.innerHTML = `<ul class="book-wheelchair__error-list"><li>${errorText}</li></ul>`;
        }
    }

    toggleFields(checkbox, parent) {
        let isChecked = checkbox.checked;
        let toggleInputs = parent.querySelectorAll('input:not([type=checkbox])');

        if (isChecked) {
            for (let i = 0; i < toggleInputs.length; i++) {
                this.checkboxToggle.classList.add('js-active');
            }
        } else {
            for (let i = 0; i < toggleInputs.length; i++) {
                this.checkboxToggle.classList.remove('js-active');
            }
        }
    }

    phoneValidation(e) {
        let errorDiv = this.phoneNumbers.querySelector('.book-wheelchair__error');
        let errorText = e.getAttribute('data-error-message');
        const phoneNumberVal = this.phoneInputs.value;
        const rgxPattern = /^[0-9]*$/;
        const rgx = new RegExp(rgxPattern);

        if (this.phoneInputs.value.length === 0 || !rgx.test(phoneNumberVal)) {
            this.phoneInputs.classList.add('parsley-error');
            errorDiv.innerHTML = `<ul class="book-wheelchair__error-list"><li>${errorText}</li></ul>`;
        } else {
            this.phoneInputs.classList.remove('parsley-error');
            errorDiv.innerHTML = '';
        }
    }

    postcodeValidation(field) {
        const POSTCODE_INPUT = field;
        const POSTCODE_PARENT = field.parentNode;
        const POSTCODE_ERROR = POSTCODE_PARENT.querySelector('.book-wheelchair__error');
        const POSTCODE = POSTCODE_INPUT.value;
        const PATTERN = /^(([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s*[0-9][A-Za-z]{2}$/;
        const REGEX = new RegExp(PATTERN);

        if (!REGEX.test(POSTCODE)) {
            POSTCODE_ERROR.innerHTML = '<ul class="book-wheelchair__error-list filled"><li>Please enter a valid UK postcode</li></ul>';
            POSTCODE_INPUT.setAttribute('aria-invalid', 'true');
            POSTCODE_INPUT.classList.remove('parsley-success');
            POSTCODE_INPUT.classList.add('parsley-error');
        } else {
            POSTCODE_ERROR.innerHTML = '';
            POSTCODE_INPUT.setAttribute('aria-invalid', 'false');
            POSTCODE_INPUT.classList.remove('parsley-error');
            POSTCODE_INPUT.classList.add('parsley-success');
        }
    }

    checkErrors() {
        const errors = document.querySelectorAll('.book-wheelchair__error-list');

        errors.forEach(err => {
            const el = err;
            const offsetTop = el.offsetTop - 250;
 
            window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            });
        })
    }
}